export default __webpack_public_path__ + "../staticImages/sprite-dhlgowhite-2x.png";